import * as React from 'react';

import { Button, SearchField } from '@rematter/ui-web';
import { useAtom } from 'jotai';
import { LucideX } from 'lucide-react';

import * as state from '../../_state/purchaseOrdersList.state';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';
import { SelectFacility } from '~/shared/components/select-fields/SelectFacility';
import { useDebouncedAtom } from '~/shared/hooks/useDebouncedAtom';

//
// ⚛️ ⚛️ ⚛️ PURCHASE ORDER FILTERS ⚛️ ⚛️ ⚛️
//
export const PurchaseOrderFilters = () => {
  const t = useTranslations();

  // Atoms
  const [searchTerm, setSearchTerm] = useDebouncedAtom(state.$searchTerm, 300);
  const [selectedFacility, setSelectedFacility] = useAtom(
    state.$selectedFacility,
  );

  const hasActiveFilters =
    (searchTerm !== undefined && searchTerm?.trim() !== '') ||
    (selectedFacility !== undefined && selectedFacility !== 'all');

  // Callbacks
  const handleClearAll = React.useCallback(() => {
    setSearchTerm('');
    setSelectedFacility(undefined);
  }, [setSearchTerm, setSelectedFacility]);

  return (
    <>
      <SearchField
        autoFocus
        placeholder={t.purchaseOrdersView.filters.search.placeholder}
        aria-label={t.purchaseOrdersView.filters.search.placeholder}
        value={searchTerm}
        className="w-[200px] shrink-0"
        onChange={(value) => setSearchTerm(value ?? '')}
      />
      <SelectFacility
        value={selectedFacility ?? 'all'}
        onChange={(value) => setSelectedFacility(value ?? 'all')}
        showAllOption
        allOptionLabel={'All Facilities'}
        className="w-[200px] shrink-0"
      />
      {hasActiveFilters && (
        <Button
          variant="text"
          color="primary"
          icon={<LucideX />}
          onPress={handleClearAll}
        >
          {t.purchaseOrdersView.filters.clearAll}
        </Button>
      )}
    </>
  );
};
